import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import map from 'lodash/map';
import { CopyStandard } from '../../../atoms/Copytext';
import Picture from '../../../atoms/Picture';
import getImageProperties from '~/helpers/getImageProperties';

/**
 * @param {SliderImage} props
 * @returns {React.ReactElement} The rendered component
 */
const renderImage = ({ src, alt, text }) => (
  <>
    <Picture
      urls={getImageProperties({ xl: src, md: src, xs: src }, 'carousel')}
      alt={alt || ''}
    />
    {text && <CopyStandard richtext={text} />}
  </>
);

/**
 * @param {SliderContentProps} element
 * @returns {React.ReactElement} The rendered component
 */
const renderSlide = (element) => {
  if ('src' in element) {
    return renderImage(element);
  }
  return element;
};

/**
 * @param {SwiperWrapperProps} props
 * @returns {React.ReactElement} The rendered component
 */
const SwiperWrapper = ({ config, content, onSwiper }) => {
  const { pagination, loop, on, ...restConfig } = config;

  return (
    <Swiper
      modules={[Pagination]}
      pagination={pagination}
      loop={loop}
      onSlideChange={on?.slideChange}
      onSwiper={onSwiper}
      {...restConfig}
    >
      {map(content, (element, index) => (
        <SwiperSlide key={`SliderItem_${index}`}>
          {renderSlide(element)}
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SwiperWrapper;
